import { useEffect } from "react";

export default function useOnClickOutside(refs, handler) {
  useEffect(() => {
    function listener(event) {
      if (document.querySelector('[data-confirmation-dialog]')) return;
      const refArray = Array.isArray(refs) ? refs : [refs];
      const validRefs = refArray.filter((ref) => ref && ref.current);

      // If no valid refs, don't handle the event
      if (validRefs.length === 0) {
        return;
      }

      // If any valid ref contains the event target, do nothing
      const isOutside = validRefs.every((ref) => !ref.current.contains(event.target));
      if (isOutside) {
        handler(event);
      }
    }

    // pointerdown is the most reliable cross-environment signal — some elements/clicks
    // suppress bubble-phase mousedown but pointerdown still fires. mousedown/touchstart
    // are kept for backwards compatibility and the (rare) case where pointer events are
    // not available.
    document.addEventListener("pointerdown", listener);
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("pointerdown", listener);
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [refs, handler]);
}
